import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import { IconFileImport, IconLoading } from '../../assets/icon';
import Text from '../Text/Text';
import uploadFile, { clearUploadFile } from '../../thunks/general/uploadFile';
import Alert from '../Alert/Alert';
import AlertType from '../../common/alertType';

const UploadFileModal = ({
  visible,
  toggleVisible
}) => {
  const [userFile, setUserFile] = useState(null);
  const dispatch = useDispatch();
  const {
    uploadFile: {
      loading,
      data,
    },
  } = useSelector((state) => ({
    uploadFile: state?.uploadFile,
  }), shallowEqual);

  const onImageChange = ({ target }) => {
    setUserFile(target.files[0]);
  };

  const onSave = () => {
    dispatch(clearUploadFile());
    dispatch(uploadFile({
      file: userFile,
    }));
  };

  useEffect(() => {
    if (data?.message) {
      setUserFile(null);
    }
  }, [data?.message]);

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="File upload"
      subTitle="File will be uploaded to the server and processed."
      hideCloseBtn
      saveText="Upload"
      onSave={onSave}
      canSave={loading || !userFile}
    >
      <div className="relative">
        {loading && (
          <div className="flex justify-center">
            <IconLoading widht={100} height={50} className="spin" />
            <Text text="Loading..." />
          </div>
        )}
        {!loading && (
          <div className="flex justify-center items-center flex-col flex-1">
            <label htmlFor="file" className="w-full">
              <div
                className="cursor-pointer flex justify-center items-center p-[5px] bg-white rounded-[8px]
                w-full h-[100px] shadowDefault hover:text-primary"
              >
                <IconFileImport className="w-[50px] h-[50px] text-text-muted" />
              </div>
              <input
                type="file"
                className="w-0 h-0 overflow-hidden opacity-0"
                name="file"
                accept=".xlsx, .xls"
                id="file"
                onChange={onImageChange}
              />
            </label>
            {userFile && (
              <Text muted text={userFile?.name} bold />
            )}
            <Text muted text="Only *.xlsx, *.xls files are accepted" textStyle="text-[10px]" />
            <Text
              muted
              text="Only ACTIVE listings will be send to ebay automaticali"
              textStyle="text-[10px]"
            />
          </div>
        )}
        <br />
        {data?.message && (
          <Alert
            text={data?.message}
            type={AlertType.info}
          />
        )}
      </div>
    </Modal>
  );
};

UploadFileModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
};

UploadFileModal.defaultProps = {
  visible: false,
  toggleVisible: () => {
  },
};

export default UploadFileModal;
